<template>
  <div>Hi CSR!</div>
</template>

<script>
export default {
  name: "Dashboard",
};
</script>
